/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Assign_StrategyInputs */

const cs_automation_assign_strategy = /** @type {(inputs: Automation_Assign_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategie přiřazení`)
};

const en_automation_assign_strategy = /** @type {(inputs: Automation_Assign_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign strategy`)
};

/**
* | output |
* | --- |
* | "Assign strategy" |
*
* @param {Automation_Assign_StrategyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_assign_strategy = /** @type {((inputs?: Automation_Assign_StrategyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Assign_StrategyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_assign_strategy(inputs)
	return cs_automation_assign_strategy(inputs)
});